import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

enum IsLoggedInCacheKey {
  IsLoggedIn = 'IsLoggedIn',
}

export const useIsLoggedInQuery = () => {
  const { isLoggedIn } = useServicesContext();
  return useQuery({
    queryKey: [IsLoggedInCacheKey.IsLoggedIn],
    queryFn: () => isLoggedIn(),
    staleTime: 30 * 1000, // 30 seconds - reduce excessive refetching
    refetchOnWindowFocus: false, // Disable window focus refetch to prevent render loops
  });
};
